export { default } from "./StandaloneReadAloudButton";
